<era-room-select-ui [rooms]="rooms$ | async"
                    (roomChange)="selected($event)"> </era-room-select-ui>

<div class="form-check">
  <input class="form-check-input"
         type="checkbox"
         value=""
         id="showRoomsWithDevices"
         [formControl]="showRoomsWithDevicesForm" />
  <label class="form-check-label"
         for="showRoomsWithDevices"> Show rooms with a device </label>
</div>